import BizImage1 from "../../images/globe.png";
export const HeroData = [
  {
    path: "/",
    label: "View Home",
    image: BizImage1,
    alt: "",
  },
];
